import { smb_fetch, getAgpApiUrl } from '@/api/operator/fetch';

export const getComplaintList = (data: any, isShowError?: boolean) => {
  const url = getAgpApiUrl('review_service', 'amscomplaint/get');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    ...data,
  }, isShowError, false);
};
